import React, { useEffect, useRef, type ReactNode } from "react";

interface Props {
  label: string;
  count?: number;
  open: boolean;
  setOpen: (v: boolean) => void;
  width?: string;
  scrollable?: boolean;
  children: ReactNode;
}

export function FilterDropdown({
  label,
  count,
  open,
  setOpen,
  width = "w-[220px]",
  scrollable = false,
  children,
}: Props) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(e: MouseEvent) {
      if (!ref.current?.contains(e.target as Node)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () =>
      document.removeEventListener("mousedown", handleClickOutside);
  }, [setOpen]);

  return (
    <div ref={ref} className="relative mb-3">
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="
        w-[150px]
        h-[50px]
        bg-[#FFFFFF]
        rounded-[12px]
        px-4
        flex items-center justify-between
        shadow-[inset_0_0_0_2px_rgba(0,0,0,0.03)]
        hover:bg-[#ececec]
        transition
        "
      >
        <span className="text-[16px] font-raleway text-black leading-none">
          {label}
          {count ? (
            <span className="ml-1 text-xs text-gray-500">
              ({count})
            </span>
          ) : null}
        </span>

        <svg
          className={`w-5 h-5 transition-transform duration-200 ${
            open ? "rotate-180" : ""
          }`}
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M6 9L12 15L18 9"
            stroke="black"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>

      {open && (
        <div
          className={`absolute top-[60px] left-0 ${width} bg-white rounded-xl border shadow-lg p-2 z-50 ${scrollable ? "max-h-[260px] overflow-auto" : ""}`}
        >
          {children}
        </div>
      )}
    </div>
  );
}
